export const MobileTabBar = {
  display: 'none',
  '@mobileL': { display: 'flex', flow: 'x' },
  align: 'center space-around',
  padding: 'Y 0',
  background: 'inkMid',
  borderTop: '1px solid inkBorder',
  position: 'sticky',
  bottom: '0',
  zIndex: '100',
  width: '100%',

  MobileTabHome: {
    extends: 'MobileTabItem',
    state: { tabKey: 'appointments', iconName: 'calendar' }
  },
  MobileTabPatients: {
    extends: 'MobileTabItem',
    state: { tabKey: 'patients', iconName: 'users' }
  },
  MobileTabCalendar: {
    extends: 'MobileTabItem',
    state: { tabKey: 'calendar', iconName: 'clock' }
  },
  MobileTabFinance: {
    extends: 'MobileTabItem',
    state: { tabKey: 'finance', iconName: 'dollarSign' }
  },
  MobileTabAi: {
    extends: 'MobileTabItem',
    state: { tabKey: 'ai', iconName: 'sparkle' }
  }
}

export const MobileTabItem = {
  tag: 'button',
  flow: 'y',
  align: 'center center',
  gap: 'X',
  padding: 'Y Z',
  cursor: 'pointer',
  flex: '1',
  color: 'inkMuted',
  background: 'none',
  border: 'none',
  isActive: (el, s) => {
    const path = window.location.pathname
    if (path === '/ai' && s.tabKey === 'ai') return true
    if (path === '/patient' && s.tabKey === 'patients') return true
    return s.root.activeTab === s.tabKey
  },
  '.isActive': { color: 'inkText' },
  onClick: (e, el, s) => {
    if (s.tabKey === 'ai') {
      window.location.href = '/ai'
      return
    }
    s.root.update({ activeTab: s.tabKey })
  },
  TabIcon: { extends: 'Icon', icon: (el, s) => s.iconName, width: 'A', height: 'A' }
}
